const when = (value) => {
  if (!value) return "";
  const d = new Date(value.endsWith?.("Z") ? value : `${value}Z`);
  if (Number.isNaN(d.getTime())) return value;
  return `${d.toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Africa/Nairobi",
  })} EAT`;
};

const OUTCOME = { won: "text-emerald-500", lost: "text-maasai", drew: "text-zinc-400" };

/** One dense row per match: the tie, the competition, the kick-off or the score. */
export const FixtureList = ({ matches, prefix, empty = "Nothing in the feed yet." }) =>
  matches?.length ? (
    <div className="border border-zinc-800" data-testid={`${prefix}-list`}>
      {matches.map((m, i) => (
        <div
          key={m.event_id || i}
          data-testid={`${prefix}-item-${i}`}
          className="flex flex-col gap-2 border-b border-zinc-900 bg-[#0b0b0b] p-5 md:flex-row md:items-center md:justify-between md:gap-8 md:p-6"
        >
          <span className="min-w-0">
            <span className="block text-sm leading-snug text-white md:text-base">
              {m.home} <span className="text-zinc-600">v</span> {m.away}
            </span>
            <span className="mono mt-2 block text-[0.55rem] uppercase tracking-[0.16em] text-zinc-500">
              {m.competition}
              {m.round ? ` · round ${m.round}` : ""}
              {m.venue ? ` · ${m.venue}` : ""}
            </span>
          </span>
          <span className="mono flex shrink-0 items-center gap-3 text-[0.6rem] uppercase tracking-[0.16em]">
            {m.played ? (
              <>
                <span className={`text-base font-bold ${OUTCOME[m.outcome] || "text-white"}`}>
                  {m.home_score}&ndash;{m.away_score}
                </span>
                <span className="text-zinc-500">{when(m.kick_off)}</span>
              </>
            ) : (
              <span className="text-ochre">{when(m.kick_off)}</span>
            )}
          </span>
        </div>
      ))}
    </div>
  ) : (
    <p className="border border-zinc-800 bg-[#0b0b0b] p-6 text-sm text-zinc-500" data-testid={`${prefix}-empty`}>
      {empty}
    </p>
  );
